import React from 'react';
import {Atom, withSystem} from '@packages/systems/wfdl';
import {
  TListOfElement,
  TTypeConstructor,
  TRecord,
  TText,
} from '@packages/systems/wfdl-ast';
import {qualify, typeName, pluginName} from '@packages/systems/wfdl-Qualified';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren, getInPojo, getTag} from '@packages/utilities/data-utils';

const NavbarMenu = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    context,
    renderChild,
    data,
    elementId,
  }) => {
    const Tag = getTag(getInPojo(data, ['tag'])) as React.ElementType;
    const navbarMenuClasses = classes.push(`w-nav-menu`);

    const isOpen = context.get('isOpen');

    return (
      <Tag
        {...generateAttributes(attributes, navbarMenuClasses)}
        key={`${elementId}-isOpen-${isOpen ? isOpen : 'false'}`}
        data-nav-menu-open={isOpen ? true : null}
      >
        {getChildren(data).map((child) => renderChild(child, context))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Nav Menu',
  constraints: {
    descendants: [
      {
        is: 'NavbarMenu',
        rule: 'Forbid',
      },
    ],
    ancestors: [
      {
        is: 'NavbarWrapper',
        rule: 'ExactlyOne',
      },
    ],
  },
  showEmpty: true,
  render: NavbarMenu,
  fields: {
    attr: TRecord({
      role: TText,
    }),
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'Nav',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
